import React, { useEffect } from "react";
import { connect } from "react-redux";

import UiSwitch from "../PageLayout/UiSwitch";
import { SortByMode } from "./SortByMode";
import { AccessRights, PARTS } from "../../schemas/accessRightsModel";
import PsActionsNew from "./ProjectScopeActionsNew";
import { postQtCategories, setQtCategories } from "../NewScope/newScopeActions";
import { getWizardList } from "../WizardSetup/wizardActions";
import ImportFeatures from "../FeatureCreator/ImportFeatures";
import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";


const ProjectScopeContentHeader = (props) => {

  const { showMode, mode, setMode, postQtCategories, setQtCategories, qtCategories, setWizardMode, isWizardMode,
    showUseWizard, showCsvPopup, categoriesVisualizer, getWizardList} = props;

  const toggleWizardClick = async () => {
    // 1) update useWizardProperty
    const useWizard = qtCategories.some(qtCategory => qtCategory.useWizard);
    const newQtCategories = qtCategories.map(qtCategory => {
      qtCategory.useWizard = !useWizard;
      return qtCategory
    });
    setQtCategories(newQtCategories); // update useWizardProperty
    postQtCategories(newQtCategories); // update useWizardProperty
    // 2) switch to the wizard logic
    setWizardMode(!isWizardMode);
    if (!isWizardMode) {
      await getWizardList(categoriesVisualizer);
    }
  }

  return (
    <div className="pj-scope-content__header">
      {
        showCsvPopup ? (
          <div className="pj-scope-content__header-left" >
            <ImportFeatures />
          </div>
        ) : null
      }
      <div className="pj-scope-content__header-right">
        {showMode ? (
          <div className="pj-scope-content__header-item">
            <SortByMode onItemClick={(item) => setMode(item)} selectedItem={mode} />
          </div>
        ) : null}
        {showUseWizard ? (
          <div className="pj-scope-content__header-item">
            <UiSwitch onClick={toggleWizardClick}
              // textId={checked ? "checkbox.on" : "checkbox.off"}
              checked={isWizardMode} />
            <span className="pj-scope-content__header-item-text">Use Wizard</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

const mapStateToProps = (store) => {
  const { mode, hasKitchen, hasBathroom } = store.projectScopeNew;
  const AR = AccessRights.get(store);
  const { qtCategories, isWizardMode } = store.newScope;
  const { categoriesVisualizer } = store.newScope;

  return {
    mode,
    showMode: (hasKitchen && hasBathroom) || AR.isSiteAdmin(false),
    showUseWizard: (AR.isSiteAdmin(true) || AR.v(PARTS.HUB_BUTTON_WIZARD))
      && (categoriesVisualizer !== AVAILABLE_VISUALIZERS.leadform),
    qtCategories,
    isWizardMode,
    categoriesVisualizer,
    showCsvPopup: AR.isSiteAdmin(true)// || AR.v(PARTS.PROJECT_SCOPE_CSV_IMPORT_EXPORT),
  }
}

const mapDispatchToProps = (dispatch) => ({
  setMode: mode => dispatch(PsActionsNew.setMode(mode)),
  postQtCategories: (qtCategories) => dispatch(postQtCategories(qtCategories)),
  setQtCategories: (qtCategories) => dispatch(setQtCategories(qtCategories)),
  setWizardMode: (isWizardMode) => dispatch(PsActionsNew.setWizardMode(isWizardMode)),
  getWizardList: (wizardVisualizer, fabricatorId, getOnly) => dispatch(getWizardList(wizardVisualizer, fabricatorId, getOnly)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectScopeContentHeader);
